/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { formatLieuActe } from './formatters';

/**
 * Construit le payload de mise à jour du bloc « INFORMATIONS SUR LA
 * RECONNAISSANCE », envoyé via `service.update`
 * (PUT `/numerisation-actes/reconnaissance/{identifiant}`).
 *
 * La date, l'heure et le lieu sont saisis UNE fois : c'est le back qui les
 * ventile vers le bloc du père, celui de la mère, ou les deux, d'après le code
 * de l'auteur.
 *
 * @param identifiant Identifiant de l'ACTE : construit l'URL du PUT.
 * @param data État du formulaire de la modale.
 * @param viderReconnaissanceNonAuteur Décision de l'agent : effacer ou non le
 * bloc du parent qui n'est plus auteur. Le back ne l'efface jamais de lui-même.
 */
const buildEvenementReconnaissanceUpdatePayload = (
  identifiant: number,
  data: Record<string, any>,
  viderReconnaissanceNonAuteur = false,
) => ({
  identifiant,
  acte: {
    identifiant,
    dateReconnaissance: data?.dateReconnaissance,
    heureReconnaissance: data?.heureReconnaissance,
    minuteReconnaissance: data?.minuteReconnaissance,
    identifiantAuteurReconnaissance: data?.identifiantAuteurReconnaissance,
    lieuReconnaissance: formatLieuActe(data?.adresseReconnaissance),
    ...(viderReconnaissanceNonAuteur && {
      viderReconnaissanceNonAuteur: true,
    }),
  },
});

export default buildEvenementReconnaissanceUpdatePayload;
